<template>
	<!-- <div class="page-wrapper">
    <b-container class="container-fluid">
      <b-row>   
          <b-row>
             <b-col cols="3">
               <SideBar/>
              </b-col>
             <b-col >                   
              <transition name="fade-transform" mode="out-in">
                <router-view/>
              </transition>
            </b-col>    
      </b-row>
    </b-container>
  </div> -->
	<!-- <div>
		<div v-if="isLaptop && hasAccess()"><SideBar /></div>
		<div>
			<transition name="fade-transform" mode="out-in">
				<router-view :class="menuStatus ? 'extra-width' : ''" />
			</transition>
		</div>
	</div> -->
	<!-- =========================================================================
	Old expanding sidebar (PUSH approach) — moves the router-view containers when
	the sidebar expands. Kept for future reference.
	<section class="app-main-wrapper d-flex align-items-stretch">
		<div
			class="app-main-sidebar"
			:class="sidebarExpanded ? 'sidebar-expanded' : 'sidebar-collapsed'"
			@mouseenter="sidebarExpanded = true"
			@mouseleave="sidebarExpanded = false"
		>
			<MainLeftpart :expanded="sidebarExpanded" />
		</div>
		<div class="app-main-content">
			<router-view :class="menuStatus ? 'extra-width' : ''" />
		</div>
	</section>
	========================================================================= -->

	<!-- New overlay sidebar (no layout push) — sidebar expands on TOP of the
	content instead of moving it -->
	<div class="app-main-wrapper">
		<div
			v-if="isLaptop && hasAccess()"
			class="app-main-sidebar d-flex invisible-scroll"
			:class="[
				sidebarOpen ? 'sidebar-expanded' : 'sidebar-collapsed',
				{ 'no-transition': noTransition },
			]"
			@mouseenter="sidebarExpanded = true"
			@mouseleave="onSidebarLeave"
		>
			<MainLeftpart
				:expanded="sidebarOpen"
				@set-expanded="onSetExpanded"
				@navigate="onNavigate"
			/>
		</div>
		<div class="app-main-content">
			<router-view :class="menuStatus ? 'extra-width' : ''" />
		</div>
	</div>
</template>

<script>
import MainLeftpart from "../LandingPage/MainLeftpart.vue";
import SideBar from "../fixedcomponents/sideBar.vue";
import { mapGetters } from "vuex";
import { hasAccess } from "@/utils/tokenCheck";

export default {
	name: "AppMain",
	data() {
		return {
			noTransition: false,
			isLaptop: true,
			sidebarExpanded: false,
			// Sidebar is "pinned" open while a collapsible submenu that contains the
			// current route is open. Keeps the dropdown visible after you navigate
			// into a module that lives inside it, rather than collapsing on hover-leave.
			sidebarPinned: false,
			components: [
				"ViewPublicProfile",
				"previewvideoresume",
				"snapshot",
				"systemcheck",
				"InterviewOngoing",
			],
		};
	},
	components: {
		MainLeftpart,
		SideBar,
	},
	computed: {
		...mapGetters("userVUEX", {
			menuStatus: "getMenuStatus",
		}),
		...mapGetters("candidateVUEX", {
			progress: "getCandProgressResp",
			progressPrimary: "getCandProgressRespPrimary",
			primaryCandidateInfo: "getPrimaryCandidateInfo",
			getcandidateInfo: "getcandidateInfo",
		}),
		sidebarOpen() {
			return this.sidebarExpanded || this.sidebarPinned;
		},
		showSidebar() {
			if (this.$route?.query?.uuid && this.$route?.query?.jobID) {
				return (
					!this.components.includes(this.$route.name) &&
					this.progressPrimary.progress >= 20 &&
					this.primaryCandidateInfo.database_demographics &&
					(this.getcandidateInfo.profileName === null ||
						this.getcandidateInfo.profileName !== null)
				);
			} else if (this.$route?.query?.uuid) {
				return (
					!this.components.includes(this.$route.name) &&
					this.progressPrimary.progress >= 20 &&
					this.primaryCandidateInfo.database_demographics &&
					this.getcandidateInfo.profileName !== null
				);
			}
			return (
				!this.components.includes(this.$route.name) &&
				this.progressPrimary.progress >= 20 &&
				this.primaryCandidateInfo.database_demographics
			);
		},
	},
	mounted() {
		this.checkScreenSize(); // Check screen size initially
		window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
		window.addEventListener("pageshow", this.onPageShow); // Restore sidebar state on bfcache return
		window.addEventListener("popstate", this.onPopState); // Restore sidebar state on history traversal
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
		window.removeEventListener("pageshow", this.onPageShow);
		window.removeEventListener("popstate", this.onPopState);
	},
	methods: {
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},

		onPageShow(event) {
			if (!event.persisted) return;
			this.resetSidebarState();
		},

		onPopState() {
			this.resetSidebarState();
		},
		resetSidebarState() {
			this.sidebarExpanded = false;
			this.sidebarPinned = false;
			window.scrollTo(0, 0);
		},

		onSetExpanded(value) {
			this.sidebarPinned = !!value;
		},

		onNavigate() {
			this.noTransition = true;
			this.sidebarExpanded = false;
			this.sidebarPinned = false;
			this.$nextTick(() => {
				setTimeout(() => {
					this.noTransition = false;
				}, 100);
			});
		},
		onSidebarLeave() {
			this.sidebarExpanded = false;
			this.sidebarPinned = false;
		},
		hasAccess() {
			return hasAccess();
		},
	},
};
</script>

<style>
.app-main-sidebar.no-transition {
	transition: none !important;
}
.app-main-wrapper {
	width: 100%;
	min-height: 100vh;
	position: relative;
}

.app-main-sidebar {
	position: absolute;
	left: 0;
	top: 62px;
	bottom: 0;
	z-index: 100;
	overflow: hidden;
	white-space: nowrap;
	transition: width 0.25s ease;
	background: #ffffff;
	border-right: 1px solid #e2e8f0;
	height: calc(100vh - 65px);
	padding: 24px 8px 24px 8px;
	box-sizing: border-box;
	flex-shrink: 0;
}

.sidebar-collapsed {
	width: 64px;
}

.sidebar-expanded {
	width: 275px;
	position: absolute;
	top: 62px;
	padding: 16px;
	height: calc(100vh - 65px);
	overflow-y: auto;
	box-sizing: border-box;
}

.app-main-content {
	width: 100%;
	min-width: 0;
}

.extra-width {
	margin-left: 180px !important;
}
</style>
